<template>
    <div>
        <v-card 
            class="pipelineDetails"
        >
            <v-progress-linear 
                :value="100"
                :color="getDueDateColor(itemProject)"
                style="margin-top: 20px"
                height="7"
            >
            </v-progress-linear>
            <v-card-text
                :class="`${checkStatusCard(itemCard, itemProject)}`"
                v-if="itemProject != null && itemCard != null"
            >
                <label class="labelMainColor" @click="goToServiceDetails(itemProject.idService)">{{ itemProject.idFormatted }}</label>

                <div
                    v-if="checkHoldSituation() == false || userLoggedGetters.profile.systemAdmin == 1"
                    class="moreOptions"
                >
                    <v-menu
                        left
                        bottom
                        :close-on-content-click="false"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="buttonMoreOptions"
                                color=""
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-if="itemCard.moreOptions.jobSpecifics"
                                :to="{ name: 'serviceDetails', params: {id: itemProject.idService} }"
                            >
                                <v-list-item-title><v-icon left>mdi-arrow-expand</v-icon> Job Specifics</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="itemCard.moreOptions.hold && itemProject.situation != 2 && userLoggedGetters.profile.systemAdmin == 1"
                                @click="showDialogHold('H')"
                            >
                                <v-list-item-title><v-icon left>mdi-car-brake-hold</v-icon> Hold</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-else-if="itemCard.moreOptions.hold && userLoggedGetters.profile.systemAdmin == 1"
                                @click="showDialogHold('R')"
                            >
                                <v-list-item-title><v-icon left>mdi-play-circle-outline</v-icon> Resume</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="itemCard.moreOptions.workOrder && accessWorkOrder"
                                @click="menuWorkOrder = true;"
                            >
                                <v-list-item-title><v-icon left>mdi-briefcase-outline</v-icon> Work Order</v-list-item-title>
                                
                                <v-menu
                                    v-model="menuWorkOrder"
                                    right
                                    top
                                    open-on-hover
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon 
                                            x-small
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-play
                                        </v-icon>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            :to="{ name: 'workOrderForm', params: { id: 0, idPanel: itemCard.idPanel, idServiceProject: itemProject.id } }"
                                        >
                                            <v-list-item-title><v-icon left>mdi-folder-plus-outline</v-icon> New</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            @click="downloadWorkOrder(itemProject.id)"
                                        >
                                            <v-list-item-title><v-icon left>mdi-download</v-icon> Download</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                            </v-list-item>

                            <v-list-item
                                v-if="itemCard.moreOptions.workOrderRequest && accessWorkOrderRequest"
                                @click="menuWorkOrderRequest = true;"
                            >
                                <v-list-item-title><v-icon left>mdi-briefcase</v-icon> Work Order Request</v-list-item-title>
                                
                                <v-menu
                                    v-model="menuWorkOrderRequest"
                                    right
                                    top
                                    open-on-hover
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon 
                                            x-small
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-play
                                        </v-icon>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            :to="{ name: 'workOrderRequestForm', params: { id: 0, idPanel: itemCard.idPanel, idServiceProject: itemProject.id } }"
                                        >
                                            <v-list-item-title><v-icon left>mdi-folder-plus-outline</v-icon> New</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            @click="downloadWorkOrderRequest(itemProject.id)"
                                        >
                                            <v-list-item-title><v-icon left>mdi-download</v-icon> Download</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                            </v-list-item>

                            <v-list-item
                                v-if="canRequestToWareHouse"
                                :to="{ name: 'warehouseOrder', params: { idServiceProject: itemProject.id } }"
                            >
                                <v-list-item-title><v-icon left>mdi-warehouse</v-icon> Warehouse Request</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="itemCard.moreOptions.inspection && accessInspection"
                                :to="{ name: 'inspectionForm', params: { id: 0, idPanel: itemCard.idPanel, idStage: itemCard.idStage, idServiceProject: itemProject.id } }"
                            >
                                <v-list-item-title><v-icon left>mdi-magnify-expand</v-icon> Inspection</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                @click="openGallery(itemProject.idService, itemProject.id)"
                            >
                                <v-list-item-title><v-icon left>mdi-camera-burst</v-icon> View Gallery</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="itemCard.moreOptions.showAdvanceButton && (userLoggedGetters.profile.systemAdmin == 1 || userLoggedGetters.profile.constructionSupervisor == 1)"
                                @click="updateStep('+', itemCard.idStatusCard)"
                            >
                                <v-list-item-title><v-icon left>mdi-page-next-outline</v-icon> Advance to the next step</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="itemCard.moreOptions.showBackButton && (userLoggedGetters.profile.systemAdmin == 1 || userLoggedGetters.profile.constructionSupervisor == 1)"
                                @click="updateStep('-', itemCard.idStatusCard)"
                            >
                                <v-list-item-title><v-icon left>mdi-page-previous-outline</v-icon> Back to previous step</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="userLoggedGetters.profile.returnCard == 1"
                                @click="showDialogStatus(itemCard)"
                            >
                                <v-list-item-title><v-icon left>mdi-page-previous-outline</v-icon> Back to...</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="userLoggedGetters.profile.returnCard == 1"
                                @click="showDialogSkipStatus(itemCard)"
                            >
                                <v-list-item-title><v-icon left>mdi-page-next-outline</v-icon> Skip to...</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="userLoggedGetters.profile.systemAdmin == 1 || userLoggedGetters.profile.constructionSupervisor == 1"
                                @click="showUploadPhotosCard(itemProject)"
                            >
                                <v-list-item-title><v-icon left>mdi-camera-plus</v-icon> Upload Photos</v-list-item-title>
                            </v-list-item>

                            <v-divider></v-divider>

                            <v-list-item
                                v-for="(itemConstruction, index) in listConstructionActions.filter(act => act.idPanel == itemCard.idPanel && act.idStage == itemCard.idStage && act.quickAccessMenu == 1 && (itemProject.kindWork == 1 ? act.projectRemodel == 1 : itemProject.kindWork == 2 ? act.projectNewPool == 1 : itemProject.kindWork == 3 ? act.projectService == 1 : true))" :key="index"
                                @click="showDialogActivities(
                                    itemProject.id,                         //idServiceProject
                                    getSubStatus(itemProject),              //statusProject
                                    itemConstruction.idPanel,               //idPanel
                                    itemConstruction.idStage,               //idStage
                                    itemConstruction.id,                    //idAction
                                    itemConstruction.labelName,             //title
                                    false,                                  //showPanelStages
                                    false                                   //readOnlyNotes
                                )"
                            >
                                <v-list-item-title><v-icon left>{{ itemConstruction.icon }}</v-icon> {{ itemConstruction.labelName }} </v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-if="listConstructionOtherActions.filter(act => act.idPanel == itemCard.idPanel && act.idStage == itemCard.idStage).length > 0"
                                @click="menuExtraActions = true"
                            >
                                <v-list-item-title><v-icon left>mdi-stretch-to-page-outline</v-icon> Other actions...</v-list-item-title>
                                
                                <v-menu
                                    v-model="menuExtraActions"
                                    right
                                    top
                                    open-on-hover
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon 
                                            x-small
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-play
                                        </v-icon>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            v-for="(itemConstruction, index) in listConstructionOtherActions.filter(act => act.idPanel == itemCard.idPanel && act.idStage == itemCard.idStage)" :key="index"
                                            @click="showDialogActivities(
                                                itemProject.id,                         //idServiceProject
                                                getSubStatus(itemProject),              //statusProject
                                                itemConstruction.idPanel,               //idPanel
                                                itemConstruction.idStage,               //idStage
                                                itemConstruction.id,                    //idAction
                                                itemConstruction.labelName,             //title
                                                false,                                  //showPanelStages
                                                false                                   //readOnlyNotes
                                            )"
                                        >
                                            <v-list-item-title><v-icon left>{{ itemConstruction.icon }}</v-icon> {{ itemConstruction.labelName }} </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>

                <v-card
                    class="d-flex background-transparent margin-top-10"
                    flat
                    tile
                >
                    <v-card
                        v-if="itemProject.kindWork == 1"
                        class="pa-2 background-transparent"
                        flat
                        tile
                    >
                        <v-tooltip
                            top
                        >
                            <template v-slot:activator="{ on }">
                                <v-chip
                                    v-on="on"
                                    color="var(--color__main)"
                                    outlined
                                    dark
                                    small
                                >
                                    {{ itemProject.kindWorkFirstLetter }}
                                </v-chip>
                            </template>
                            <span>{{ itemProject.kindWorkDescription }}</span>
                        </v-tooltip>
                    </v-card>

                    <v-card
                        v-if="checkHoldSituation()"
                        class="pa-2 background-transparent"
                        flat
                        tile
                    >
                        <v-tooltip
                            top
                        >
                            <template v-slot:activator="{ on }">
                                <v-chip
                                    v-on="on"
                                    :color="getSituationColor()"
                                    outlined
                                    dark
                                    small
                                >
                                    {{ itemProject.situationDescription }} - {{ itemProject.dateHoldDays }}
                                </v-chip>
                            </template>
                            <span>{{ itemProject.notesHold }}</span>
                        </v-tooltip>
                    </v-card>

                    <v-card
                        class="pa-2 background-transparent"
                        flat
                        tile
                    >
                        <v-chip
                            :color="getClassificationColor(itemProject.classification)"
                            outlined
                            dark
                            small
                        >
                            {{ itemProject.classification }} - {{ itemProject.classificationDescription }}
                        </v-chip>
                    </v-card>
                </v-card>

                <label>{{ itemProject.customerName }}</label>
                <v-chip
                    v-if="getActiveTracksBadge(itemProject) > 1"
                    x-small
                    color="orange"
                    text-color="white"
                    class="ml-1 multi-track-badge"
                    @click="showDialogMultiTrack()"
                >
                    <v-icon x-small left>mdi-source-branch</v-icon>
                    {{ getActiveTracksBadge(itemProject) }} tracks
                </v-chip>
                <br />
                <label>{{ itemProject.customerAddress }} </label>
                <br />
                <label>{{ itemProject.customerCity }} </label>
                <br v-if="haveGateCode()" />
                <label v-if="haveGateCode()">Gate Code: {{ itemProject.customerAddressGateCode }}</label>
                <br />
                <span>{{ itemProject.customerPhone }}</span>
                <br />
                <span>{{ itemProject.customerEmail }}</span>

                <h5 style="color: #bbb">Contracted on: {{ itemProject.dateContractedFormatted }}</h5>

                <h5 style="color: #bbb">
                    Deadline: <strong>{{ itemProject.dueDateFormatted }}
                    <span :style="itemProject.dueDateDeadlineDays == 2 ? 'color: var(--color__pipeline_deadline_warning)' : itemProject.dueDateDeadlineDays < 2 ? 'color: var(--color__pipeline_deadline_over_due)' : 'color: var(--color__pipeline_deadline_ok)'">( {{ itemProject.dueDateDeadlineDaysDescription }} )</span> </strong>
                </h5>
            </v-card-text>
            
            <v-divider></v-divider>

            <v-card-actions
                :class="`${checkStatusCard(itemCard, itemProject)}`"
                v-if="itemCard.showSelectSupervisor"
            >
                <v-col 
                    cols="12"
                >                            
                    <div class="marginInfoBottom" />

                    <v-icon left>mdi mdi-account-question-outline</v-icon>
                    <label>No supervisor</label>
                    <v-tooltip 
                        top
                    >
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                v-on="on"
                                @click="showDialogSupervisor(itemProject.id)"
                                style="float: right; cursor: pointer;"
                                right 
                            >
                                mdi mdi-account-hard-hat-outline
                            </v-icon>
                        </template>
                        <span>Select a supervisor</span>
                    </v-tooltip>
                </v-col>
            </v-card-actions>

            <v-card-actions
                :class="`${checkStatusCard(itemCard, itemProject)}`"
                v-else
            >
                <v-col 
                    cols="12"
                >
                    <div class="marginInfoBottom" />

                    <v-icon color="var(--color__main) !important" left>mdi mdi-account-check-outline</v-icon>
                    <label class="userAssigned">{{ itemProject.userNameSupervisor }}</label>
                </v-col>
            </v-card-actions>

            <v-card-actions
                :class="`${checkStatusCard(itemCard, itemProject)}`"
            >
                <v-col 
                    class="margin-top"
                    cols="6"
                    lg="8"
                    md="6"
                    sm="6"
                >
                    <v-icon left>mdi mdi-account-tie</v-icon>
                    <label >{{ itemProject.sellerName }}</label>
                    
                    <br />
                    <div class="marginInfoBottom" />

                    <v-icon left>mdi mdi-file-sign</v-icon>
                    <label>{{ itemProject.nameProject }}</label>
                </v-col>
                <v-col 
                    class="contractValue"
                    cols="6"
                    lg="4"
                    md="6"
                    sm="6"
                >
                    <br />
                    <div class="marginInfoBottom" />

                    <label>{{ itemProject.contractValueFormatted }}</label>

                    <br />
                    <div class="marginInfoBottom" />

                    <v-menu
                        right
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="buttonMoreInformation"
                                color=""
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi mdi-information-slab-circle-outline</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-card>
                                <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                    Upcoming Activities
                                </v-card-title>
                                <v-card-text>
                                    <v-data-table
                                        style="margin-top: 10px;"
                                        :headers="headersConstructionItems"
                                        :items="listConstructionItems"
                                        :options.sync="optionsConstructionItems"
                                        :loading="loading"
                                        :items-per-page="10"
                                        no-data-text="No Record Found"
                                    >
                                    </v-data-table>
                                </v-card-text>                                                
                            </v-card>
                        </v-list>
                    </v-menu>

                </v-col>
            </v-card-actions>

            <v-card-actions 
                :class="`justify-center ${checkStatusCard(itemCard, itemProject)}`"
            >
                <v-col
                    v-if="checkHoldSituation(itemProject)"
                    cols="2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__red)"
                                left 
                                v-on="on"
                                large    
                            >
                                mdi mdi-close-octagon
                            </v-icon>
                        </template>
                        <span>Hold [{{ itemProject.dateHoldDays }}] - {{ itemProject.notesHold }} </span>
                    </v-tooltip>
                </v-col>

                <v-col 
                    cols="2"
                    v-if="itemProject.dueDateDeadlineDays < 2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__alert)"
                                v-on="on" 
                                left
                                large
                            >
                                mdi mdi-alert-octagram
                            </v-icon>
                        </template>
                        <span>Late</span>
                    </v-tooltip>
                </v-col>
                <v-col 
                    v-if="itemProject.showIconBBQ == 1"
                    cols="2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__construction_dashboard_bbq)"
                                left 
                                v-on="on"
                                large    
                            >
                                mdi mdi-grill-outline
                            </v-icon>
                        </template>
                        <span>Barbecue</span>
                    </v-tooltip>
                </v-col>
                <v-col 
                    v-if="itemProject.showIconPergola == 1"
                    cols="2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__construction_dashboard_pergola)"
                                left 
                                v-on="on"
                                large    
                            >
                                mdi mdi-home-roof
                            </v-icon>
                        </template>
                        <span>Outdoor</span>
                    </v-tooltip>
                </v-col>

                <v-col
                    v-if="itemProject.showIconNotes == 1"
                    cols="2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__construction_dashboard_bbq)"
                                left 
                                v-on="on"
                                large
                                @click="goToServiceDetails(itemProject.idService)"
                            >
                                mdi mdi-notebook-edit-outline
                            </v-icon>
                        </template>
                        <span>Notes</span>
                    </v-tooltip>
                </v-col>

                <v-col 
                    v-if="itemProject.showIconMarketing == 1"
                    cols="2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__construction_dashboard_bbq)"
                                left 
                                v-on="on"
                                large    
                            >
                                mdi mdi-cast-education
                            </v-icon>
                        </template>
                        <span>Have marketing material</span>
                    </v-tooltip>
                </v-col>

                <v-col 
                    v-for="(itemProduct, index) in itemProject.listProductsWithIcons" :key="index"
                    cols="2"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__construction_dashboard_bbq)"
                                left 
                                v-on="on"
                                large    
                            >
                                {{ itemProduct.iconProduct }}
                            </v-icon>
                        </template>
                        <span> {{ itemProduct.productDescription }} </span>
                    </v-tooltip>
                </v-col>

                <v-col 
                    cols="2"
                    v-if="showImportantMessage(itemProject)"
                >
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-icon 
                                color="var(--color__alert)"
                                left 
                                v-on="on" 
                                large
                            >
                                mdi mdi-note-alert-outline
                            </v-icon>
                        </template>
                        <span>{{ itemProject.importantMessage }}</span>
                    </v-tooltip>
                </v-col>

                <v-col
                    cols="2"
                >
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-list-item-icon v-on="on">
                                <v-badge
                                    :content="itemProject.qtyUnRead"
                                    :value="itemProject.qtyUnRead"
                                    left
                                    overlap
                                    color="var(--color__red)"
                                >
                                    <v-icon color="var(--color__main)" large @click="goToServiceDetails(itemProject.idService)">mdi mdi-bell-outline</v-icon>
                                </v-badge>
                            </v-list-item-icon>
                        </template>
                        <span>Unviewed notes</span>
                    </v-tooltip>
                </v-col>
            </v-card-actions>

        </v-card>

        <DialogHold 
            :id="dialogHoldResume.id"
            :type="dialogHoldResume.type"
            v-on:methodConfirmToCall="dialogHoldResume.methodConfirm"
            :showDialogHold.sync="dialogHoldResume.show"
        />
        
        <DialogStatus
            :id="dialogStatus.id"
            :listStatus="dialogStatus.listStatus"
            :title="dialogStatus.title"
            :skipRulesConstructionStages="dialogStatus.skipRulesConstructionStages"
            v-on:methodConfirmToCall="dialogStatus.methodConfirm"
            :showDialogStatus.sync="dialogStatus.show"
        />
        
        <DialogActivities
            :idAux="dialogActivity.idAux"
            :idServiceProject="dialogActivity.idServiceProject"
            :statusProject="dialogActivity.statusProject"
            :idPanel="dialogActivity.idPanel"
            :idStage="dialogActivity.idStage"
            :idAction="dialogActivity.idAction"
            :status="dialogActivity.status"
            :title="dialogActivity.title"
            :itemProject="{...itemProject}"
            :showPanelStages="dialogActivity.showPanelStages"
            :readOnlyNotes="dialogActivity.readOnlyNotes"
            :listContractor="listContractor"
            :listConstructionPanel="listConstructionPanel"
            :listConstructionStages="listConstructionStages"
            v-on:methodConfirmToCall="dialogActivity.methodConfirm"
            :showDialogActivities.sync="dialogActivity.show"
        />
        
        <DialogSelectSupervisor
            :id="dialogSupervisor.id"
            :idStatusToUpdate="dialogSupervisor.idStatusToUpdate"
            :listUser="listUser"
            v-on:methodConfirmToCall="dialogSupervisor.methodConfirm"
            :showDialogSupervisor.sync="dialogSupervisor.show"
        />

        <ShowFiles 
            :showFiles.sync="dialogShowFiles.show"
            :idServiceProject="dialogShowFiles.idServiceProject"
            :title.sync="dialogShowFiles.title"
            :showAsCarrousel.sync="dialogShowFiles.showAsCarrousel"
            :showFilters.sync="dialogShowFiles.showFilters"
            :reload="dialogShowFiles.reload"
            :listParams="dialogShowFiles.listParams"
            :lockedModuleId="dialogShowFiles.moduleId"
            :lockedStatusId="dialogShowFiles.statusId"
        />

        <v-dialog
            v-model="dialogMultiTrack.show"
            max-width="500"
            persistent
        >
            <v-card>
                <v-card-title class="text-h6" style="border-bottom: solid 1px #ccc;">
                    <v-icon left color="orange">mdi-source-branch</v-icon>
                    Active Tracks - {{ itemProject ? itemProject.idFormatted : '' }}
                </v-card-title>
                <v-card-text style="padding-top: 15px;">
                    <p>This project is currently active in <strong>{{ dialogMultiTrack.tracks.length }}</strong> phases simultaneously:</p>
                    <v-list dense>
                        <v-list-item
                            v-for="(track, index) in dialogMultiTrack.tracks"
                            :key="index"
                            @click="goToPipeline(track.trackType)"
                            style="cursor: pointer;"
                        >
                            <v-list-item-icon>
                                <v-icon color="var(--color__main)">{{ getTrackIcon(track.trackType) }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ track.trackTypeDescription }}</v-list-item-title>
                                <v-list-item-subtitle>{{ track.statusDescription }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogMultiTrack.show = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
	</div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import { required } from "@/utilities/Rules";
    import { orderBy } from '@/utilities/Utils';
    import DialogHold from "@/components/Services/DialogHold";
    import DialogStatus from "@/components/Services/DialogStatus";
    import DialogActivities from "@/components/Services/DialogActivities";
    import DialogSelectSupervisor from "@/components/Services/DialogSelectSupervisor";
    import ShowFiles from "@/components/File/ShowFiles";
    import { 
        PROJECT_STATUS,
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT,
        TRACK_TYPE
    } from "@/utilities/Enums";
    import { getTrackCardClass, getActiveTrackCount } from "@/utilities/TrackUtils";

	export default {

        mixins: [Helpers],

        components: {
            DialogHold,
            DialogStatus,
            DialogActivities,
            DialogSelectSupervisor,
            ShowFiles
        },

        props: {
			
            id: {
                type: Number,
                default: 0
            },
			
            itemProject: {
                type: Object,
                default: null
            },
			
            itemCard: {
                type: Object,
                default: null
            },

            firstStatus: {
                type: Number,
                default: 0
            },

            lastStatus: {
                type: Number,
                default: 0
            },

            listStatusOriginal: {
                type: Array,
                default: () => []
            },

            listConstructionActions: {
                type: Array,
                default: () => []
            },

            salesModule: {
                type: Object,
                default: () => ({})
            },

            draftingModule: {
                type: Object,
                default: () => ({})
            },

            listContractor: {
                type: Array,
                default: () => []
            },

            listConstructionPanel: {
                type: Array,
                default: () => []
            },

            trackType: {
                type: Number,
                default: 0
            },

            listConstructionStages: {
                type: Array,
                default: () => []
            },

            listUser: {
                type: Array,
                default: () => []
            },
		},
		
        data: () => ({

            dialogHoldResume: {
                id: 0,
                type: "H",
                show: false,
                methodConfirm: ( () => {} ),
            },

            listStatus: [],
            dialogStatus: {
                id: 0,
                listStatus: [],
                title: "Select status to back",
                skipRulesConstructionStages: false,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogActivity: {
                idAux: 0,
                idServiceProject: 0,
                statusProject: 0,
                idPanel: 0,
                idStage: 0,
                idAction: 0,
                status: 0,
                title: "",
                show: false,
                showPanelStages: false,
                readOnlyNotes: false,
                methodConfirm: ( () => {} ),
            },

            dialogSupervisor: {
                id: 0,
                idStatusToUpdate: 0,
                show: false,
                methodConfirm: ( () => {} ),
            },

            menuWorkOrder: false,
            menuWorkOrderRequest: false,
            menuExtraActions: false,
            accessWorkOrder: false,
            accessWorkOrderRequest: false,
            accessInspection: false,
            
            loading: false,

            listConstructionItems: [ 
                { id: 1, userNameRegister: 'Rayane Tavares', dateRegisterFormatted: '03/30/2023 09:12', stageDescription: 'Locates', targetDateFormatted: '04/02/2023 09:00'},
                { id: 2, userNameRegister: 'Rayane Tavares', dateRegisterFormatted: '03/30/2023 11:54', stageDescription: 'Rebar', targetDateFormatted: ''},
            ],

            headersConstructionItems: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Phase", value: "stageDescription", sortable: true },
                { text: "Target", value: "targetDateFormatted", sortable: true },
                { text: "Created By", value: "userNameRegister", sortable: true },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
            ],
            
            optionsConstructionItems: { rowsPerPage: 10, page: 1 },

            validations: {
                required: required
            },
            
            dialogShowFiles: {
                show: false,
                idServiceProject: 0,
                title: '',
                showAsCarrousel: true,
                showFilters: false,
                reload: 0,
                listParams: [],
                moduleId: 0,
                statusId: 0
            },

            dialogMultiTrack: {
                show: false,
                tracks: []
            },

            PROJECT_STATUS
		}),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            canRequestToWareHouse() {
                return this.userLoggedGetters.profile.canRequestToWareHouse == 1;
            },

            listConstructionOtherActions() {
                return this.listConstructionActions.filter(act => act.quickAccessMenu != 1);
            },
        },

        methods: {

            getSubStatus(itemProject) {
                if (itemProject.bbq == 1)           return itemProject.statusBBQ;
                if (itemProject.pergola == 1)       return itemProject.statusPergola;
                if (itemProject.statusFence == 1)   return itemProject.statusFence;
                if (itemProject.statusService == 1) return itemProject.statusService;
                return itemProject.status;
            },

            showImportantMessage(item) {
                return item.importantMessage != null && 
                       item.importantMessage != undefined && 
                       item.importantMessage.toString().trim() != ""
            },

            checkStatusCard(itemCard, itemProject) {

                if (this.checkHoldSituation() == true) {
                    return 'card-hold';
                }

                // Use track-aware card class if trackType is specified
                if (this.trackType > 0 && itemProject.activeTracks && itemProject.activeTracks.length > 0) {
                    return getTrackCardClass(itemProject, itemCard.idStatusCard, this.trackType);
                }
            },

            getActiveTracksBadge(itemProject) {
                return getActiveTrackCount(itemProject);
            },

            showDialogMultiTrack() {
                if (this.itemProject && this.itemProject.activeTracks && this.itemProject.activeTracks.length > 1) {
                    this.dialogMultiTrack.tracks = this.itemProject.activeTracks.filter(t => t.trackType != TRACK_TYPE.PERMITTING.id && t.status != 19);
                    this.dialogMultiTrack.show = true;
                }
            },

            getTrackIcon(trackType) {
                switch (trackType) {
                    case TRACK_TYPE.PREDIG.id: return 'mdi-shovel';
                    case TRACK_TYPE.FRONTEND.id: return 'mdi-hammer';
                    case TRACK_TYPE.GRADING_PLUMBING.id: return 'mdi-pipe';
                    case TRACK_TYPE.TILE_DECK.id: return 'mdi-border-all';
                    case TRACK_TYPE.EQUIPMENT_ELECTRIC.id: return 'mdi-flash';
                    case TRACK_TYPE.PREP_PLASTER.id: return 'mdi-format-paint';
                    case TRACK_TYPE.FENCE.id: return 'mdi-fence';
                    case TRACK_TYPE.BBQ.id: return 'mdi-grill-outline';
                    case TRACK_TYPE.PERGOLA.id: return 'mdi-home-roof';
                    case TRACK_TYPE.POOL.id: return 'mdi-pool';
                    case TRACK_TYPE.SERVICE.id: return 'mdi-wrench';
                    default: return 'mdi-circle-outline';
                }
            },

            goToPipeline(trackType) {
                this.dialogMultiTrack.show = false;
                switch (trackType) {
                    case TRACK_TYPE.PREDIG.id: this.$router.push({ path: '/construction/pipelinePreDig' }); break;
                    case TRACK_TYPE.FRONTEND.id: this.$router.push({ path: '/construction/pipelineFrontEnd' }); break;
                    case TRACK_TYPE.GRADING_PLUMBING.id: this.$router.push({ path: '/construction/pipelineGradingPlumbing' }); break;
                    case TRACK_TYPE.TILE_DECK.id: this.$router.push({ path: '/construction/pipelineTileDeck' }); break;
                    case TRACK_TYPE.EQUIPMENT_ELECTRIC.id: this.$router.push({ path: '/construction/pipelineEquipmentElectric' }); break;
                    case TRACK_TYPE.PREP_PLASTER.id: this.$router.push({ path: '/construction/pipelinePrepPlaster' }); break;
                    case TRACK_TYPE.FENCE.id: this.$router.push({ path: '/construction/pipelineFence' }); break;
                    case TRACK_TYPE.BBQ.id: this.$router.push({ path: '/construction/pipelineBBQ' }); break;
                    case TRACK_TYPE.PERGOLA.id: this.$router.push({ path: '/construction/pipelinePergola' }); break;
                }
            },
			
            getClassificationColor (classification) {

                let color = "";

                switch (classification) {

                    case 0:
                        color = 'var(--color__silver)';
                        break;

                    case 1:
                        color = 'var(--color__red)';
                        break;

                    case 2:
                        color = 'var(--color__alert)';
                        break;

                    case 3:
                        color = 'var(--color__main)';
                        break;

                    case 4:
                        color = 'var(--color__blue)';
                        break;
                }

                return color
            },
			
            getSituationColor () {

                let color = "";

                switch (this.itemProject.situation) {

                    //OPEN
                    case 1:
                        color = 'var(--color__main)';
                        break;

                    //HOLD
                    case 2:
                        color = 'var(--color__card_hold)';
                        break;

                    //CANCELED
                    case 3:
                        color = 'var(--color__completed)';
                        break;
                }

                return color
            },
            
            haveGateCode() {

                if (this.itemProject != null) {
                    return this.itemProject.customerAddressGateCode != null && this.itemProject.customerAddressGateCode != undefined && this.itemProject.customerAddressGateCode != ''
                }
            },

            goToServiceDetails(id) {
                this.$router.push({ name: "serviceDetails", params: { id } });
            },

            checkHoldSituation() {
                return this.itemProject.situation == 2
            },

            async showDialogHold(type) {
                this.dialogHoldResume = {
                    id: this.id,
                    show: true,
                    type,
                    methodConfirm: ( () => {  
                        this.$emit('methodConfirmToCall');
                    })
                }
            },

            async updateStep(type, actualStatus) {

                // let status = parseInt(this.itemProject.status);
                let status = parseInt(actualStatus);

                if (type == '+') {
                    status++
                }
                else {
                    status--
                }
                
                const updateStatusRequest = { id: this.id };

                if (parseInt(this.itemProject.statusBBQ) === parseInt(actualStatus)) {
                    updateStatusRequest.statusBBQ = status;
                } else if (parseInt(this.itemProject.statusPergola) === parseInt(actualStatus)) {
                    updateStatusRequest.statusPergola = status;
                } else if (parseInt(this.itemProject.statusFence) === parseInt(actualStatus)) {
                    updateStatusRequest.statusFence = status;
                } else if (parseInt(this.itemProject.statusService) === parseInt(actualStatus)) {
                    updateStatusRequest.statusService = status;
                } else {
                    updateStatusRequest.status = status;
                }

                const result = await this.$store.dispatch("serviceModule/UpdateProjectStatus", updateStatusRequest);

                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                    this.$emit('methodConfirmToCall');
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                }
            },

            showDialogStatus(itemCard) {
                this.listStatus = this.listStatusOriginal.filter(sts => sts.id >= 3 && sts.id < itemCard.idStatusCard && [4, 13].includes(sts.id) == false).sort((a, b) => { return orderBy(a, b, 0, 'id') });

                this.dialogStatus = {
                    id: this.id,
                    listStatus: this.listStatus,
                    title: "Select status to back",
                    skipRulesConstructionStages: true,
                    show: true,
                    methodConfirm: ( () => { 
                        this.$emit('methodConfirmToCall');
                    })
                }
            },

            showDialogSkipStatus(itemCard) {
                this.dialogStatus = {
                    id: this.id,
                    listStatus: this.listStatusOriginal.filter(sts => sts.id > itemCard.idStatusCard),
                    title: "Select status to skip",
                    skipRulesConstructionStages: true,
                    show: true,
                    methodConfirm: ( () => { 
                        this.$emit('methodConfirmToCall');
                    })
                }
            },

            async showDialogActivities(
                idServiceProject,
                statusProject,
                idPanel, 
                idStage, 
                idAction, 
                title, 
                showPanelStages, 
                readOnlyNotes
            ) {
                this.dialogActivity = {
                    idAux: Math.random(),
                    idServiceProject,
                    statusProject,
                    idPanel: idPanel,
                    idStage: idStage,
                    idAction: idAction,
                    title: title,
                    show: true,
                    showPanelStages,
                    readOnlyNotes,
                    methodConfirm: ( () => { 
                        this.$emit('methodConfirmToCall');
                    })
                }
            },

            async showDialogSupervisor(id) {
                this.dialogSupervisor = {                    
                    id,
                    idStatusToUpdate: this.PROJECT_STATUS.CONSTRUCTION_PREDIG_PRESITE.id,
                    show: true,
                    methodConfirm: ( () => { 
                        this.$emit('methodConfirmToCall');
                    })
                }
            },

            async showUploadPhotosCard(itemProject) {
                
                const listNote = await this.$store.dispatch("serviceModule/ListProjectNote", { 
                    idService: 0, 
                    idServiceProject: itemProject.id, 
                    onlyCheckExists: false, 
                    idStatus: 0,
                    idPanel: 0,
                    idStage: 0,
                    idUser: 0
                } );
                    
                let listParams = [];

                listNote.forEach(itemNote => {
                    listParams.push({
                        stageDescription: itemNote.statusDescription,
                        typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                        typeDocument: TYPE_DOCUMENT.NOTE.value,
                        typeAttachmentDescription: '',
                        typeDocumentDescription: '',
                        idKey: itemNote.id,
                        isImage: true
                    });
                });

                this.dialogShowFiles = {
                    show: true,
                    idServiceProject: itemProject.id,
                    moduleId: 4,
                    statusId: this.getSubStatus(itemProject),
                    reload: Math.random(),
                    listParams
                };
            },

            async downloadWorkOrder(id) {

                this.showLoading();

                this.$vanKirkApi.get(`workOrder/download-from-project/${id}`, {
                        responseType: "blob",
                    })
                    .then((response) => {

                        var blob = new Blob([response.data], {
                            type: "application/pdf",
                        });

                        var url = window.URL.createObjectURL(blob);
                        window.open(url);

                        this.getRegisters();
                        this.hideLoading();
                    })
                    .catch(() => {
                        this.showToast("error", "Erro!", "No work order found");
                        this.hideLoading();
                    }
                );
            },

            dueDateIsLate(item) {
                return item.dueDateDeadlineDays < 2;
            },

            getStatusHighlightColor(itemCard, itemProject) {
                const statusCardClass = this.checkStatusCard(itemCard, itemProject);

                switch (statusCardClass) {
                    case 'card-hold':
                        return 'var(--color__yellow)';
                    case 'card-with-problem':
                        return 'var(--color__red)';
                    case 'card-waiting-solve-problem':
                        return 'var(--color__pipeline_deadline_warning)';
                    default:
                        return '';
                }
            },

            getDueDateColor(item) {
                const statusHighlightColor = this.getStatusHighlightColor(this.itemCard, item);

                if (statusHighlightColor) {
                    return statusHighlightColor;
                }

                let color = item.dueDateDeadlineDays == 2 ? 'var(--color__pipeline_deadline_warning)' : item.dueDateDeadlineDays < 2 ? 'var(--color__pipeline_deadline_over_due)' : 'var(--color__pipeline_deadline_ok)'

                if (item.status == this.firstStatus) {
                    color = 'var(--color__pipeline_incoming_projects)'
                }
                else if (item.status > this.lastStatus) {
                    color = 'var(--color__pipeline_deadline_ok)'
                }

                return color;
            },
            
            async openGallery(idService, idServiceProject) {

                if (idService != null && idService != undefined) {

                    let listParams = [];
                    let idLoadCalculation = 0;
                    let idColorSelection = 0;

                    this.listProjects = await this.$store.dispatch("serviceModule/ListProject", idService);

                    const responseLoadCalculation = await this.$store.dispatch("serviceModule/GetLoadCalculationById", { id: idService, idAddress: 0 } );
                    if (responseLoadCalculation.success) {
                        idLoadCalculation = responseLoadCalculation.result.id;
                    }

                    const responseColorSelection = await this.$store.dispatch("serviceModule/GetColorSelectionById", idService);
                    if (responseColorSelection.success) {
                        idColorSelection = responseColorSelection.result.id;
                    }

                    const listNote = await this.$store.dispatch("serviceModule/ListProjectNote", { 
                        idService: 0, 
                        idServiceProject, 
                        onlyCheckExists: false, 
                        idStatus: 0,
                        idPanel: 0,
                        idStage: 0,
                        idUser: 0
                    } );

                    this.listProjects.forEach(itemProject => {

                        idServiceProject = itemProject.id

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.POOL_STUDIO_IMAGES.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams = [];
                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.DIMENSIONED_EQUIPMENT_LOCATION.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.FENCE_LOCATION.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.DEPH_DEEPEST_POINT_LOCATION.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.LIGHT_LOCATIONS.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.SOIL_TEST.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.PERGOLAS.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.WATER_FEATURES.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.BBQ.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.POOL_STUDIO_IMAGES.value,
                            idKey: idServiceProject,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.LOAD_CALCULATION.value,
                            typeDocument: TYPE_DOCUMENT.LOAD_CALCULATION_PICTURES.value,
                            idKey: idLoadCalculation,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.salesModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.COLOR_SELECTION.value,
                            typeDocument: TYPE_DOCUMENT.COLOR_SELECTION_PICTURES.value,
                            idKey: idColorSelection,
                            isImage: true
                        })

                        listParams.push({
                            stageDescription: this.draftingModule.moduleDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.DRAFTING_IMAGES.value,
                            idKey: idServiceProject,
                            isImage: true
                        })
                    });
                    
                    listNote.forEach(itemNote => {
                        listParams.push({
                            stageDescription: itemNote.statusDescription,
                            typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
                            typeDocument: TYPE_DOCUMENT.NOTE.value,
                            typeAttachmentDescription: '',
                            typeDocumentDescription: '',
                            idKey: itemNote.id,
                            isImage: true
                        });
                    });

                    this.dialogShowFiles = {
                        show: true,
                        idServiceProject,
                        showAsCarrousel: true,
                        reload: Math.random(),
                        listParams
                    };
                }
            },
            
            async checkAccess() {
                this.accessWorkOrder = false;
                this.accessWorkOrderRequest = false;
                this.accessInspection = false;

                const listRoutesFromLocalStorage = localStorage.getItem('listRouters');

                if (listRoutesFromLocalStorage !== null && listRoutesFromLocalStorage !== undefined) {
                    const listRoutesJSON = JSON.parse(listRoutesFromLocalStorage)

                    let accessRoute = listRoutesJSON.filter(rte => rte.name == 'workOrder');
                    this.accessWorkOrder = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'workOrderRequest');
                    this.accessWorkOrderRequest = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'inspection');
                    this.accessInspection = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;
                }

            },
        },

        async created() {
            await this.checkAccess();
        }
    };
</script>

<style scoped>

    .v-card__actions {
        padding: 0px;
    }

    .buttonMoreInformation {
        border: none; 
        height: 0px;
    }

    .margin-top {
        margin-top: 0px;
    }

</style>
